import { SearchEntryItem } from '../get-data/transform/link-recommender-list';

export const UPDATE_LINK_RECOMMENDER_LIST = 'UPDATE_LINK_RECOMMENDER_LIST';

export const updateLinkRecommenderList = (payload: SearchEntryItem[]) => ({
    type: UPDATE_LINK_RECOMMENDER_LIST,
    payload,
});

export default (
    state: SearchEntryItem[] = [],
    action: ReturnType<typeof updateLinkRecommenderList>
) => (action.type === UPDATE_LINK_RECOMMENDER_LIST ? [...state, ...action.payload] : state);
